 
export const SHOW_LOADER            =   "SHOW_LOADER"
export const TOASTR                 =   "TOASTR" 
export const FETCH_USER_DETAILS     =   "FETCH_USER_DETAILS"
export const NAVIGATE_TO_SETTING    =   "NAVIGATE_TO_SETTING"
export const FORCE_OPEN_DIALPAD     =   "FORCE_OPEN_DIALPAD"
export const FETCH_STATUS_LIST      =   "FETCH_STATUS_LIST"
export const FETCH_BILLING_PLAN     =   "FETCH_BILLING_PLAN"
export const FETCH_USER_CREDENTIALS =   "FETCH_USER_CREDENTIALS"